import React from 'react';
import { TypedMemo } from '../../common/types';
import { RemoveCatalogItemModal } from './RemoveCatalogItemModal';
import { SMLCreationSheet } from '../creationSheet/SMLCreationSheet';
import { CatalogRowModalsState } from './useCatalogRowModals';
import { useCatalogItemActions } from './useCatalogItemActions';
import { MergeSongsModal } from './merge/MergeSongsModal';

interface CatalogRowModalsProps {
  accountId: number;
  modals: CatalogRowModalsState;
  itemActions: ReturnType<typeof useCatalogItemActions>;
}

/** The modals a catalog row opens: remove, merge and the creation sheet. */
const CatalogRowModalsComponent: React.FC<CatalogRowModalsProps> = ({ accountId, modals, itemActions }) => (
  <>
    <RemoveCatalogItemModal
      item={modals.itemToRemove}
      closeModal={modals.closeRemove}
      onConfirm={itemActions.removeItem}
      isLoading={itemActions.isLoading}
      error={itemActions.error}
    />
    <MergeSongsModal accountId={accountId} source={modals.itemToMerge} closeModal={modals.closeMerge} />
    <SMLCreationSheet
      accountId={accountId}
      isOpen={modals.createFor !== undefined}
      closeModal={modals.closeCreate}
      initialCatalogTrackMaid={modals.creationSource.catalogTrackMaid}
      initialCatalogItemUuid={modals.creationSource.catalogItemUuid}
    />
  </>
);

export const CatalogRowModals = TypedMemo(CatalogRowModalsComponent);
